import {useLazyQuery, gql} from '@apollo/client'
import taskQueryResult from './queryResults/useTaskResult'

export const UseGetAllUserTasks = () => {
  // Sirve para traer todas las tasks de un alumno.
  // Pero esta misma query la podemos usar para traer las tasks de una universidad,
  // solo las de un cierto estado, etc.
  return useLazyQuery(
    gql`query(
            $universitieId: ID
            $status: [StatusTask!]
            $planId: ID!
              )
              {
        getUserTasks(universitieId: $universitieId
                     status: $status
                     planId: $planId
    ) {
        ${taskQueryResult}
    }
}`,
    {
      fetchPolicy: 'no-cache',
    },
  )
}
